
    <span
      [matTooltip]="tooltip$ | async | translate"
      [class.font-weight-bold]="isGroup$ | async"
    >
      {{ value | format_number }}
    </span>
  